import { render, staticRenderFns } from "./ResendCountdown.vue?vue&type=template&id=ae98fb62&scoped=true&"
import script from "./ResendCountdown.vue?vue&type=script&lang=js&"
export * from "./ResendCountdown.vue?vue&type=script&lang=js&"
import style0 from "./ResendCountdown.vue?vue&type=style&index=0&id=ae98fb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae98fb62",
  null
  
)

export default component.exports